import { UserStatus } from "@/app/shared/utils/enums";

export const menusIndex = [
  "Workspace",
  "Informes",
  "Supervisión",
  "CRM",
  "Operaciones",
  "Flujos",
  "Canales",
  "PBX",
  "Agenda",
  "Correo",
  "Conexiones",
  // "Gestion de Usuarios",
  // "Chatbots",
  // "Importaciones",
  // "Estrategias",
  // "Reportes",
  // "Ajustes",
];

const UserCreationType = Object.freeze({
  Email: 1,
  Generated: 2,
});

const REGISTRATION_TYPES = {
  [UserCreationType.Email]: {
    value: UserCreationType.Email,
    title: "Usuario invitado",
  },
  [UserCreationType.Generated]: {
    value: UserCreationType.Generated,
    title: "Usuario creado",
  },
};

const USER_STATUS_TAGS = {
  [UserStatus.active]: {
    color: "green",
    title: "Activo",
  },
  [UserStatus.inactive]: {
    color: "red",
    title: "Inactivo",
  },
  [UserStatus.delete]: {
    color: "red",
    title: "Eliminado",
  },
  [UserStatus.pending]: {
    color: "default",
    title: "Pendiente",
  },
};

export { UserCreationType, REGISTRATION_TYPES, USER_STATUS_TAGS };
